import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import contentClient from '../../../../../utils/apiClients/contentClient';
import filesClient from '../../../../../utils/apiClients/filesClient';
import string2xml from '../../../../../utils/string2xml';
import xml2json from '../../../../../utils/xml2json';
import formatting from '../../../../../utils/formatting';
import getPrettyError from '../../../../../utils/getPrettyError';
import pathUtil from '../../../../../utils/pathUtil';
import rootReducer from './reducers/rootReducer';
import { fromXml, toXml } from './serializers';
var DashboardStateContext = React.createContext(null);
var DashboardDispatchContext = React.createContext(null);

function DashboardProvider(_ref) {
  var children = _ref.children;

  var _React$useReducer = React.useReducer(rootReducer, {}),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  return React.createElement(DashboardStateContext.Provider, {
    value: state
  }, React.createElement(DashboardDispatchContext.Provider, {
    value: dispatch
  }, children));
}

function useDashboardState() {
  var context = React.useContext(DashboardStateContext);

  if (context === undefined) {
    throw new Error('useDashboardState must be used within a DashboardStateContext');
  }

  return context;
}
/**
 * @return {import('./types').dashboardDispatch}
 */


function useDashboardDispatch() {
  var context = React.useContext(DashboardDispatchContext);

  if (context === undefined) {
    throw new Error('useDashboardDispatch must be used within a DashboardDispatchContext');
  }

  return context;
}

var getEdmPath = function getEdmPath(dashboardState, dashboardPath) {
  return pathUtil.absolute(dashboardState.dashboard.dtLocalDataModel.dtDiagramDatasource.src, pathUtil.getFolderPath(dashboardPath));
};
/**
 * @param {import('./types').dashboardDispatch} dispatch
 */


function reset(_x, _x2, _x3) {
  return _reset.apply(this, arguments);
}

function _reset() {
  _reset = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(dispatch, workspace, path) {
    var bidContent, newState, dataPath;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return contentClient.getContent(workspace, path);

          case 3:
            bidContent = _context.sent;
            newState = fromXml(bidContent);
            dispatch({
              type: 'reset',
              payload: newState
            });
            dataPath = getEdmPath(newState, path);
            _context.next = 9;
            return loadData(dispatch, workspace, dataPath);

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            dispatch({
              type: 'error',
              payload: getPrettyError(_context.t0)
            });

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));
  return _reset.apply(this, arguments);
}

function save(_x4, _x5, _x6, _x7) {
  return _save.apply(this, arguments);
}
/**
 * @param {import("./types").dashboardDispatch} dispatch
 */


function _save() {
  _save = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(dispatch, workspace, path, content) {
    var xmlContent;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            xmlContent = toXml(content);
            _context2.next = 4;
            return filesClient.saveFile(workspace, path, xmlContent);

          case 4:
            dispatch({
              type: 'document_saved',
              payload: content
            });
            _context2.next = 10;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            dispatch({
              type: 'error',
              payload: getPrettyError(_context2.t0)
            });

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _save.apply(this, arguments);
}

function loadData(_x8, _x9, _x10) {
  return _loadData.apply(this, arguments);
}

function _loadData() {
  _loadData = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(dispatch, workspace, dataPath) {
    var edmContent, edmContentJson;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            dispatch({
              type: 'set_data_loading',
              payload: true
            });
            _context3.prev = 1;
            _context3.next = 4;
            return contentClient.getContent(workspace, dataPath);

          case 4:
            edmContent = _context3.sent;
            edmContentJson = xml2json(string2xml(edmContent), {
              elementNameFn: function elementNameFn(name) {
                return formatting.dashToCamelCase(name.indexOf('das:') === 0 ? name.substring(4) : name);
              },
              attributeNameFn: formatting.dashToCamelCase,
              attributesKey: 'attributes'
            });
            dispatch({
              type: 'set_data_tables',
              payload: getOutputTable(edmContentJson.job.biUniverseOutput.biUniverse)
            });
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](1);
            dispatch({
              type: 'set_data_error',
              payload: getPrettyError(_context3.t0)
            });

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 9]]);
  }));
  return _loadData.apply(this, arguments);
}

function getOutputTable(biUniverse) {
  return makeArray(biUniverse.biUniverseTable).map(function (biUniverseTable) {
    return {
      name: biUniverseTable.attributes.name,
      dimensions: makeArray(biUniverseTable.biUniverseDimension).map(function (biUniverseDimension) {
        return {
          name: biUniverseDimension.attributes.name,
          type: biUniverseDimension.attributes.type
        };
      })
    };
  });
}

function makeArray(object) {
  if (Array.isArray(object)) return object;
  return [object];
}

export { DashboardProvider, useDashboardState, useDashboardDispatch, reset, save };